import React, { FC } from 'react';
import { Breadcrumbs, BreadcrumbsItem } from 'fronton-react';
import { useSelector } from 'react-redux';
import { sectionStyle as commonSectionStyle } from 'common/styles/section';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { getBreadcrumbs } from 'features/page-model/ducks/get-model';
import { cx } from 'linaria';
import { analyticsUtils, patchUrlByLocale } from 'utils';
import { sectionStyle } from './style';
import { getBreadcrumbsPath } from './utils/get-breadcrumbs-path';
import { filterBreadcrumbs } from './utils/filter-breadcrumbs';

export const DATA_QA_BREADCRUMB = 'breadcrumb';

export const BreadcrumbsSection: FC = () => {
  const breadcrumbsModel = useSelector(getBreadcrumbs) || [];
  const { smMobile } = useBreakpoints() || {};

  const breadcrumbs = filterBreadcrumbs(breadcrumbsModel, Boolean(smMobile));

  function sendGA(index: number) {
    const elementBlock = getBreadcrumbsPath(breadcrumbs);
    const elementText = getBreadcrumbsPath(breadcrumbs.slice(0, index + 1));

    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementName: 'breadcrumbs',
      elementText,
      elementBlock,
    });
  }

  return (
    <section className={cx(sectionStyle, commonSectionStyle)}>
      <Breadcrumbs>
        {breadcrumbs.map((breadcrumb, index) => (
          <BreadcrumbsItem
            key={breadcrumb.label}
            onClick={() => sendGA(index)}
            href={patchUrlByLocale(breadcrumb.link)}
            data-qa={DATA_QA_BREADCRUMB}
          >
            {breadcrumb.label}
          </BreadcrumbsItem>
        ))}
      </Breadcrumbs>
    </section>
  );
};
